import { memo } from 'react';
import { UmbracoTypes } from '~/lib/data-contract';
import useBasketRecommendationsProducts from '~/services/loop54/hooks/selectors/useBasketRecommendationsResults';
import { CarouselWithItems } from './helpers';

function M30BasketRecommendationsProductCarousel({
    headline,
    productIds,
}: Omit<UmbracoTypes.IM30BasketRecommendationProductCarouselModule, 'type'>) {
    const { data } = useBasketRecommendationsProducts(productIds);

    return <CarouselWithItems data={data?.results?.items} headline={headline} />;
}

export default memo(M30BasketRecommendationsProductCarousel);
